// extracted by mini-css-extract-plugin
export default {"customCategory":"style_customCategory__X8meN"};